<template>
  <div class="form-input">
    <label :for="id">
      {{ label }}
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" size="20" color="warning">
            mdi-information
          </v-icon>
        </template>
        <span>{{ bookData.couponInfo }}</span>
      </v-tooltip>
    </label>
    <div class="d-flex align-center">
      <v-form lazy-validation>
        <v-text-field
          class="mt-4 text-field"
          :id="id"
          v-model="value"
          @input="$emit('input', value)"
          :readonly="disabled"
          :disabled="disabled"
          outlined
          dense
          :clearable="!disabled"
          :color="'#FFA903'"
          flat
          style="border-radius: 0 !important;"
          :error-messages="isError && bookData.couponError"
          :error="isError"
        />
      </v-form>
      <v-btn
        @click="send"
        :disabled="disabled"
        class="secondary-btn mx-2 mb-3"
        :color="isError ? 'error' : 'none'"
        :loading="loading"
      >
        <v-icon v-if="disabled">
          mdi-check
        </v-icon>
        <span v-else>{{ bookData.couponButtonTitle }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { fetchCoupon } from "@/api/registration";

export default {
  name: "Coupon",
  props: {
    id: String,
    value: String,
    rules: Array,
    label: String,
    disabled: Boolean
  },
  computed: {
    bookData() {
      return this.$t("book");
    }
  },
  data: () => ({
    isError: false,
    loading: false
  }),
  methods: {
    async send() {
      if (this.value) {
        this.loading = true;
        try {
          const key = this.$store.getters.getSessionKey.key;
          const result = await fetchCoupon(key, this.value);
          if (result) {
            this.isError = false;
            if (result.type === 1) {
              this.$emit("getCoupon", result.amount);
            } else {
              const room = localStorage.getItem("room");
              if (!room) return;
              const price = JSON.parse(room).price;
              const percent = (price * result.amount) / 100;
              this.$emit("getCoupon", percent);
            }
            this.disabled = true;
          }
        } catch (e) {
          this.isError = true;
        }
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
form
  width: 100%
</style>
